import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import {
  Breadcrumb, BreadcrumbItem,
  Row, Col,
  Input, InputGroup, InputGroupAddon,
  Label,
  Badge, Alert,
  TabContent, TabPane,
  Nav, NavItem, NavLink,
  Button, ButtonGroup,
  Card, CardHeader, CardBlock,
  ButtonDropdown, DropdownToggle, DropdownMenu,
  Form, FormGroup
} from 'reactstrap'
import {
  FaTrashO,
  FaEye,
  FaPlus,
  FaCaretUp,
  FaCaretDown,
  FaCopy
} from 'react-icons/lib/fa'
import ConfirmButton from '../../components/ConfirmButton'
import SlateEditor from '../../components/SlateEditor'
import CreatePageModal from '../../components/CreatePageModal'
import CreateFragmetModal from '../../components/CreateFragmetModal'
import PublishModal from '../../components/PublishModal'
import PagesTable from '../../components/PagesTable'
import Upload from '../../components/Upload'
import styles from './EditPage.scss'
import moment from 'moment'
import Pagination from '../../components/Pagination'

class EditPage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTab: 'content',
      isPublishModalOpen: false,
      isFragmentList: false,
      isFragment: false,
      isStandardPage: true
    }
  }

  componentWillReceiveProps (nextProps) {
    // if page ID changes, reset tabs and scroll to top of page
    if (this.props.pageId !== nextProps.pageId) {
      window.scrollTo(0, 0)
      this.setState({ activeTab: 'content' })
    } else if (this.props.isLoading === true && nextProps.isLoading === false) {
      // Fragment list = parent fragments page
      const isFragmentList = nextProps.parents && nextProps.parents.length === 0 && nextProps.slug === 'fragments'
      const isFragment = nextProps.parents && nextProps.parents.length === 1 && nextProps.parents[0].slug === 'fragments'
      this.setState({
        isFragmentList,
        isFragment,
        isStandardPage: !isFragmentList && !isFragment,
        activeTab: isFragmentList ? 'pages' : 'content'
      }, this.addDefaultSection)
    }
  }

  addDefaultSection = () => {
    if (this.state.isFragment && this.props.slug === 'contact-us' && this.props.sections.length === 0) {
      this.props.onAddSection(0)
    }
  }
  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }

  onPageSort = ({oldIndex, newIndex}) => {
    this.props.onPageSort(oldIndex, newIndex)
  }

  toggleDraftDropdown = () => {
    this.setState({ draftDropdownOpen: !this.state.draftDropdownOpen })
  }

  togglePublishedDropdown = () => {
    this.setState({ publishedDropdownOpen: !this.state.publishedDropdownOpen })
  }

  togglePublishModal = () => {
    this.setState({isPublishModalOpen: !this.state.isPublishModalOpen})
  }

  disableAddButton = () => {
    const disable = ((this.props.sections && !this.props.isLoading && this.props.sections.length === 1 && this.props.sections[0].layout === 'maintenance') ||
   (this.props.sections && !this.props.isLoading && this.props.sections.length > 1 && this.props.sections[0].layout === 'contact'))
    return disable
  }
  render () {
    if (process.env.NODE_ENV !== 'test' && this.props.isLoading) return <div>Loading...</div>
    return (
      <div className={styles.EditPage}>
        <div>
          <Breadcrumb>
            <BreadcrumbItem><Link to='/'>Home</Link></BreadcrumbItem>
            <BreadcrumbItem><Link to='/pages'>Pages</Link></BreadcrumbItem>
            {this.props.parents && this.props.parents.map((parent, i) =>
              <BreadcrumbItem key={parent.id}><Link to={`/pages/edit/${parent.id}`}>{parent.title}</Link></BreadcrumbItem>
            )}
            <BreadcrumbItem active>{this.props.title}</BreadcrumbItem>
          </Breadcrumb>
        </div>

        <Row>
          <Col xs='12'>
            {
              this.props.requeueCount > 5 &&
              <Alert color='info'>
                We are having some issues saving this page. Try refreshing.
              </Alert>
            }
            {
              this.props.isScheduledForPast() &&
              <Alert color='warning'>
                This page is being published. Was scheduled for
                {` ${moment(this.props.scheduledFor).fromNow()}.`}
              </Alert>
            }
          </Col>
          <Col xs='6'><h3>
            {this.state.isStandardPage && 'Edit Page'}
            {this.state.isFragmentList && 'Fragments'}
            {this.state.isFragment && this.props.title}
          </h3></Col>
          <Col xs='6' className='text-right pl-2'>
            {this.state.isStandardPage && <ConfirmButton disabled={this.props.isCopying} title='Copy Page' message='Are you sure you want to copy this page?' onConfirm={this.props.onCopyPage} >Copy Page</ConfirmButton>}
            <Badge className='float-right'>{this.props.isSaving ? 'Saving' : ''}</Badge>{' '}
            <PublishModal
              onPublishNow={this.props.onPublishNow}
              onPublishLater={this.props.onPublishLater}
              scheduledFor={this.props.scheduledFor}
              toggle={this.togglePublishModal}
              isOpen={this.state.isPublishModalOpen} />
            { !this.state.isFragmentList && !this.props.isSaving && this.props.draftId &&
              <span>
                <ButtonDropdown className='ml-1' isOpen={this.state.draftDropdownOpen} toggle={this.toggleDraftDropdown}>
                  <DropdownToggle caret>Draft</DropdownToggle>
                  <DropdownMenu className={styles.dropdownMenu}>
                    {
                      this.props.scheduledFor &&
                      moment().diff(moment(this.props.scheduledFor)) < 0 &&
                      <span>Will publish <a onClick={this.togglePublishModal} href='#'>{moment(this.props.scheduledFor).fromNow()}</a> </span>
                    }
                    <Button color='primary' onClick={this.togglePublishModal}>Publish Draft</Button>&nbsp;
                    <ConfirmButton title='Delete Draft' message='Are you sure you want to delete this draft?' onConfirm={this.props.onDeleteDraft} color='danger'>Delete</ConfirmButton>
                  </DropdownMenu>
                </ButtonDropdown>
              </span>
            }
            { !this.props.isSaving && this.props.publishedId &&
              <span>
                <ButtonDropdown className='ml-1' isOpen={this.state.publishedDropdownOpen} toggle={this.togglePublishedDropdown}>
                  <DropdownToggle color='primary' caret>Published</DropdownToggle>
                  <DropdownMenu className={styles.dropdownMenu}>
                    <ConfirmButton title='Unpublish Page' message='Are you sure you want to unpublish this page?' onConfirm={this.props.onUnpublish} color='danger'>Unpublish Page</ConfirmButton>
                  </DropdownMenu>
                </ButtonDropdown>
              </span>
            }
          </Col>
        </Row>
        {this.state.isStandardPage && <Row>
          <Col>
            <Input placeholder='Page Title' size='lg'
              className='mb-1 mt-1'
              onChange={this.props.onTitleChange} value={this.props.title} />
            <Input placeholder='Head Title' size='md'
              className='mb-1 mt-1' maxLength='100'
              onChange={this.props.onHeadTitleChange}
              value={this.props.headTitle} />
            <Input placeholder='Page Description' size='md'
              className='mb-1 mt-1'
              onChange={this.props.onDescriptionChange}
              value={this.props.description} />
          </Col>
        </Row>}
        {this.state.isStandardPage && <Row>
          <Col>
            <InputGroup className='mt-1'>
              <InputGroupAddon>
                <span>{'Slug: '}</span>
              </InputGroupAddon>
              {
                this.props.parents && this.props.parents.length > 0 &&
                <InputGroupAddon>
                  <div>
                    {
                      this.props.parents.map((parent, i) =>
                        <span key={parent.id}><Link to={`/pages/edit/${parent.id}`}>{parent.slug}</Link>{' / '}</span>
                      )
                    }
                  </div>
                </InputGroupAddon>
              }
              <Input onChange={this.props.onSlugChange} value={this.props.slug} />
              {
                (this.props.draftId || this.props.publishedId) &&
                <InputGroupAddon>
                  <a href='#' onClick={this.props.onPreview}><FaEye style={{marginBottom: '4px'}} /> { this.props.draftId ? 'Preview' : 'View' }</a>
                </InputGroupAddon>
              }
            </InputGroup>
          </Col>
        </Row>}
        {this.state.isStandardPage && <Row>
          <Col>
            <InputGroup className='mt-1'>
              <InputGroupAddon>
                <span>{'Canonical URL: '}</span>
              </InputGroupAddon>
              {
                this.props.parents && this.props.parents.length > 0 &&
                <InputGroupAddon>
                  <div>
                    {
                      this.props.parents.map((parent, i) =>
                        <span key={parent.id}>
                          <Link to={`${process.env.WEBSITE_URI}/${parent.canonical}`}>
                            {`${process.env.WEBSITE_URI}/${parent.canonical}`}
                          </Link>{' / '}
                        </span>
                      )
                    }
                  </div>
                </InputGroupAddon>
              }
              <Input onChange={this.props.onCanonicalChange} value={this.props.canonical} />
            </InputGroup>
          </Col>
        </Row>}
        {(this.state.isFragment && !this.props.slug.includes('compliance')) && <Row>
          <Col>
            <InputGroup className='mt-1'>
              <InputGroupAddon>
                <span>{'Slug: '}</span>
              </InputGroupAddon>
              {
                this.props.parents && this.props.parents.length > 0 &&
                <InputGroupAddon>
                  <div>
                    {
                      this.props.parents.map((parent, i) =>
                        <span key={parent.id}><Link to={`/pages/edit/${parent.id}`}>{parent.slug}</Link>{' / '}</span>
                      )
                    }
                  </div>
                </InputGroupAddon>
              }
              <Input onChange={this.props.onSlugChange} value={this.props.slug} />
              {
                (this.props.draftId || this.props.publishedId) &&
                <InputGroupAddon>
                  {this.props.slug !== 'contact-us' && <a href='#' onClick={() => this.props.onPreview('/')}><FaEye style={{marginBottom: '4px'}} /> { this.props.draftId ? 'Preview' : 'View' }</a> }
                  {this.props.slug === 'contact-us' && <a href='#' onClick={() => this.props.onDirectPreview('/contact')}><FaEye style={{marginBottom: '4px'}} /> { this.props.draftId ? 'Preview' : 'View' }</a>}
                </InputGroupAddon>
              }
            </InputGroup>
          </Col>
        </Row>}
        {this.state.isStandardPage && <Nav tabs className='mt-2 mb-2'>
          <NavItem>
            <NavLink
              className={classnames(styles.tabTitle, { active: this.state.activeTab === 'content' })}
              onClick={() => { this.toggleTab('content') }}
            >
              Content
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames(styles.tabTitle, { active: this.state.activeTab === 'pages' })}
              onClick={() => { this.toggleTab('pages') }}
            >
              Pages {this.props.pages && this.props.pages.length > 0 && this.props.childPageTotal > 0 && <Badge>{this.props.childPageTotal}</Badge>}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames(styles.tabTitle, { active: this.state.activeTab === 'settings' })}
              onClick={() => { this.toggleTab('settings') }}
            >
              Settings
            </NavLink>
          </NavItem>
        </Nav>}
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId='content' className={styles.contentTab}>
            <Button color='primary' disabled={this.disableAddButton()} className='mb-2 mt-2' onClick={() => this.props.onAddSection(0)}><FaPlus /> {this.state.isFragment ? 'Add Item' : 'Add Section'}</Button>
            {this.props.sections && !this.props.isLoading && this.props.sections.length === 0 && <p>This page has no content</p>}
            {
              this.props.sections && this.props.sections.map((section, i) => {
                const layout = section.layout || 'sidebar'

                const onTitleChange = (e) => {
                  this.props.onSectionChange('title', e.target.value, i)
                }
                const onLinkChange = (e) => {
                  this.props.onSectionChange('link', e.target.value, i)
                }
                const onDescChange = (e) => {
                  this.props.onSectionChange('description', e.target.value, i)
                }
                const onPropertyChange = (e) => {
                  this.props.onSectionChange(e.target.name, e.target.value, i)
                }
                const onLayoutChange = (e) => {
                  const newLayout = e.target.value
                  if (newLayout === 'landing' && this.props.sections.length > 1) {
                    return alert('Landing section must be only section on page.')
                  }
                  this.props.onSectionChange('layout', newLayout, i)
                }
                const onBorderChange = (e) => {
                  this.props.onSectionChange('border', e.target.value, i)
                }
                const onSidebarLocationChange = (e) => {
                  this.props.onSectionChange('sidebarLocation', e.target.value, i)
                }
                const onAlertTypeChange = (e) => {
                  this.props.onSectionChange('alert', e.target.value, i)
                }
                const onLayoutTypeChange = (e) => {
                  this.props.onSectionChange('layoutType', e.target.value, i)
                }
                const onMainContentChange = (serializedContent) => {
                  this.props.onSectionChange('content', serializedContent, i)
                }
                const onSidebarContentChange = (serializedContent) => {
                  this.props.onSectionChange('sidebar', serializedContent, i)
                }
                const onAddSection = () => {
                  this.props.onAddSection(i)
                }
                const onRemoveSection = () => {
                  this.props.onRemoveSection(i)
                }
                const onMoveUp = () => {
                  this.props.onMoveSection(i, i - 1)
                }
                const onMoveDown = () => {
                  this.props.onMoveSection(i, i + 1)
                }
                const onCopy = () => {
                  this.props.onCopySection(i)
                }
                const onImageUpload = file => {
                  if (!file || !file.location) return
                  this.props.onSectionChange('image', file, i)
                }

                return <div key={(section.key || i) + 'Section'}>
                  {i > 0 && <Button color='primary' disabled={this.props.sections && !this.props.isLoading && this.props.sections.length === 1 && this.props.sections[0].layout === 'maintenance'} className='mb-2 mt-2' onClick={onAddSection}><FaPlus /> {this.state.isFragment ? 'Add Item' : 'Add Section'}</Button>}
                  <Row key={section.key || i}>
                    <Col>
                      <Card className='mb-2' style={{ backgroundColor: '#eee' }}>
                        {/* Standard page layout types */}
                        {this.state.isStandardPage && <CardBlock>
                          <Row>
                            <Col xs='5'>
                              {(layout === 'sidebar' || layout === 'landing') && <Input placeholder='Section Title (Optional)'
                                onChange={onTitleChange}
                                value={section.title} />}
                            </Col>
                            <Col xs='7' className='text-right'>
                              {section.layout !== 'landing' && section.layout !== 'maintenance' && <Input type='select'
                                onChange={onBorderChange}
                                value={section.border}
                                className='mr-2'
                                style={{width: 'auto', display: 'inline-block'}}>
                                <option value={null}>Default Border</option>
                                <option value='gray'>Gray Border</option>
                                <option value='none'>No Border</option>
                              </Input>}
                              <Input type='select'
                                onChange={onLayoutChange}
                                value={section.layout}
                                className='mr-2'
                                style={{width: 'auto', display: 'inline-block'}}>
                                <option value='sidebar'>Layout: Sidebar</option>
                                <option value='fullwidth'>Layout: Full-width</option>
                                <option value='landing'>Layout: Landing</option>
                              </Input>
                              <ButtonGroup className='mr-2'>
                                {i > 0 && <Button title='Move Up' onClick={onMoveUp}><FaCaretUp /></Button>}
                                {i < this.props.sections.length - 1 && <Button title='Move Down' onClick={onMoveDown}><FaCaretDown /></Button>}
                              </ButtonGroup>
                              <Button className='mr-2' title='Copy Section' onClick={onCopy} color='primary'><FaCopy /></Button>
                              <ConfirmButton title='Delete Section' message='Are you sure you want to delete this section?' onConfirm={onRemoveSection} color='danger'><FaTrashO /></ConfirmButton>
                            </Col>
                          </Row>

                          <div className={styles.contentLabel}>Main Content</div>
                          <SlateEditor
                            readOnly={this.props.readOnly}
                            onResetDidModifySections={this.props.onResetDidModifySections}
                            didModifySections={this.props.didModifySections}
                            pageId={this.props.pageId}
                            parentId={this.props.parentId}
                            match={this.props.match}
                            history={this.props.history}
                            content={section.content}
                            isTestEnv={this.props.isTestEnv}
                            onDocumentChange={onMainContentChange} />
                          {layout === 'landing' && <div>
                            <div className={styles.contentLabel}>Link</div>
                            <Input placeholder='Link location' onChange={onLinkChange} value={section.link} />
                            <div className={styles.contentLabel}>Background Image</div>
                            {section.image && <div>
                              <a target='_blank' href={section.image.location}>{section.image.originalName}</a>
                            </div>}
                            <Upload accept='image/*' onFinish={onImageUpload} />
                          </div>}
                          {layout === 'sidebar' && <div>
                            <Row className='mt-1'>
                              <Col xs='5'>
                                <div className={styles.contentLabel}>Sidebar Content</div>
                              </Col>
                              <Col xs='7' className='text-right'>
                                <Input type='select'
                                  onChange={onSidebarLocationChange}
                                  value={section.sidebarLocation || 'after'}
                                  size='sm'
                                  style={{width: 'auto', display: 'inline-block'}}>
                                  <option value='after'>Mobile Layout: Sidebar after main content</option>
                                  <option value='before'>Mobile Layout: Sidebar before main content</option>
                                </Input>
                              </Col>
                            </Row>
                            <SlateEditor
                              readOnly={this.props.readOnly}
                              onResetDidModifySections={this.props.onResetDidModifySections}
                              didModifySections={this.props.didModifySections}
                              pageId={this.props.pageId}
                              parentId={this.props.parentId}
                              match={this.props.match}
                              history={this.props.history}
                              content={section.sidebar}
                              isTestEnv={this.props.isTestEnv}
                              onDocumentChange={onSidebarContentChange} />
                          </div>}
                        </CardBlock>}
                        {/* Fragment layout types */}
                        {this.state.isFragment && (layout === 'carousel' || layout === 'news' || layout === 'banner' || layout === 'maintenance' || layout === 'contact') && <CardBlock>
                          <Row>
                            <Col xs='9'>
                              {(layout === 'maintenance') && <div>
                                <div className={styles.contentLabel}>Headline</div>
                                <Input name='headline' onChange={onPropertyChange} value={section.headline} />
                                <div className={styles.contentLabel}>Description</div>
                                <Input name='description' onChange={onPropertyChange} value={section.description} />
                                <div className={styles.contentLabel}>Additional Description</div>
                                <Input name='additionalDescription' onChange={onPropertyChange} value={section.additionalDescription} />
                                <div className={styles.contentLabel}>Bold Text</div>
                                <Input name='boldDescription' onChange={onPropertyChange} value={section.boldDescription} />
                              </div>}
                              {(layout === 'contact' && i === 0) && <div>
                                <div className={styles.contentLabel}>Title</div>
                                <Input name='title' onChange={onPropertyChange} value={section.title} />
                                <div className={styles.contentLabel}>Address 1</div>
                                <Input name='address1' onChange={onPropertyChange} value={section.address1} />
                                <div className={styles.contentLabel}>Address 2</div>
                                <Input name='address2' onChange={onPropertyChange} value={section.address2} />
                                <div className={styles.contentLabel}>Phone</div>
                                <Input name='phone' onChange={onPropertyChange} value={section.phone} />
                                <div className={styles.contentLabel}>Image</div>
                                {section.image && <div>
                                  <a target='_blank' href={section.image.location}>{section.image.originalName}</a>
                                  <Link className={styles.mLeft} to={`/files/${section.image.id}/replace`}>Edit</Link>
                                </div>}
                                <Upload accept='image/*' onFinish={onImageUpload} />
                              </div>}
                              {(layout === 'contact' && i > 0) && <div>
                                <Input type='select'
                                  onChange={onLayoutTypeChange}
                                  value={section.layoutType}
                                  className='mr-2'
                                  style={{ width: 'auto', display: 'inline-block' }}>
                                  <option value='officeAddress'>Address</option>
                                  <option value='officeContact'>Contact</option>
                                </Input>
                                {section.layoutType === 'officeAddress' &&
                                  <div>
                                    <div className={styles.contentLabel}>Title</div>
                                    <Input name='title' onChange={onPropertyChange} value={section.title} />
                                    <div className={styles.contentLabel}>Address 1</div>
                                    <Input name='address1' onChange={onPropertyChange} value={section.address1} />
                                    <div className={styles.contentLabel}>Address 2</div>
                                    <Input name='address2' onChange={onPropertyChange} value={section.address2} />
                                    <div className={styles.contentLabel}>Phone</div>
                                    <Input name='phone' onChange={onPropertyChange} value={section.phone} />
                                  </div>
                                }
                                {section.layoutType === 'officeContact' &&
                                  <div>
                                    <div className={styles.contentLabel}>Title</div>
                                    <Input name='title' onChange={onPropertyChange} value={section.title} />
                                    <div className={styles.contentLabel}>Description</div>
                                    <Input name='description' onChange={onPropertyChange} value={section.description} />
                                    <div className={styles.contentLabel}>Phone</div>
                                    <Input name='phone' onChange={onPropertyChange} value={section.phone} />
                                    <div className={styles.contentLabel}>Email</div>
                                    <Input name='email' onChange={onPropertyChange} value={section.email} />
                                  </div>
                                }
                              </div>}
                              {(layout === 'carousel' || layout === 'news') && <Input placeholder='Title (Optional)' onChange={onTitleChange} value={section.title} />}
                              {layout === 'banner' && <Input type='select'
                                onChange={onAlertTypeChange}
                                value={section.alert}
                                className='mr-2'
                                style={{width: 'auto', display: 'inline-block'}}>
                                <option value='reminder'>Alert: Reminder</option>
                                <option value='note'>Alert: Note</option>
                                <option value='important'>Alert: Important</option>
                              </Input>}
                            </Col>
                            {(layout !== 'contact') && <Col xs='3' className='text-right'>
                              <ButtonGroup className='mr-2'>
                                {i > 0 && <Button title='Move Up' onClick={onMoveUp}><FaCaretUp /></Button>}
                                {i < this.props.sections.length - 1 && <Button title='Move Down' onClick={onMoveDown}><FaCaretDown /></Button>}
                              </ButtonGroup>
                              <ConfirmButton title='Delete Section' message='Are you sure you want to delete this section?' onConfirm={onRemoveSection} color='danger'><FaTrashO /></ConfirmButton>
                            </Col> }
                            {(layout === 'contact' && i > 0) && <Col xs='3' className='text-right'>
                              <ButtonGroup className='mr-2'>
                                {i > 1 && <Button title='Move Up' onClick={onMoveUp}><FaCaretUp /></Button>}
                                {i < this.props.sections.length - 1 && <Button title='Move Down' onClick={onMoveDown}><FaCaretDown /></Button>}
                              </ButtonGroup>
                              <ConfirmButton title='Delete Section' message='Are you sure you want to delete this section?' onConfirm={onRemoveSection} color='danger'><FaTrashO /></ConfirmButton>
                            </Col> }
                          </Row>
                          {(layout === 'carousel' || layout === 'news') && <div>
                            <div className={styles.contentLabel}>Image</div>

                            {section.image && <div>
                              <a target='_blank' href={section.image.location}>{section.image.originalName}</a>
                              <Link className={styles.mLeft} to={`/files/${section.image.id}/replace`}>Edit</Link>
                            </div>}

                            <Upload accept='image/*' onFinish={onImageUpload} />
                          </div>}
                          { layout !== 'maintenance' && layout !== 'contact' && <div className={styles.contentLabel}>{layout === 'banner' ? 'Link' : 'Link / Video (YouTube, mp4)'}</div> }
                          { layout !== 'maintenance' && layout !== 'contact' && <Input placeholder={layout === 'banner' ? 'Link' : 'Link or video location'} onChange={onLinkChange} value={section.link} /> }
                          {(layout === 'news' || layout === 'banner') && <div>
                            <div className={styles.contentLabel}>Description</div>
                            <Input onChange={onDescChange} value={section.description} />
                          </div>}
                        </CardBlock>}
                      </Card>
                    </Col>
                  </Row>
                </div>
              })
            }

          </TabPane>
          <TabPane tabId='pages'>
            {this.state.isStandardPage && <CreatePageModal key={new Date().getTime()} parentId={this.props.pageId} />}
            {this.state.isFragmentList && <CreateFragmetModal key={new Date().getTime()} parentId={this.props.pageId} />}
            { this.props.pages && this.props.pages.length > 0 &&
              <div>
                <PagesTable
                  fragments={this.state.isFragmentList}
                  onSorts={{}}
                  pages={this.props.pages}
                  onPageSort={this.onPageSort} />

                <Pagination
                  updateRoute={false}
                  currentPage={this.props.childPageNumber}
                  onChangePage={this.props.onChildPageChange}
                  total={this.props.childPageTotal}
                  limit={this.props.childPageLimit}
                  history={this.props.history}
                  match={this.props.match} />
              </div>
            }
          </TabPane>
          <TabPane tabId='settings'>
            <Card className='mb-2'>
              <CardHeader>Show this page in tabs/menus</CardHeader>
              <CardBlock>
                <Label check>
                  <Input type='checkbox' checked={this.props.showTab === true || this.props.showTab === 1} onChange={this.props.onShowTabChange} />{'  '}
                  This page will be included in site navigation menus and tabs of sibling pages
                </Label>
              </CardBlock>
            </Card>
            <Card className='mb-2'>
              <CardHeader>Override page title within tabs/menus</CardHeader>
              <CardBlock>
                <Label>
                  If specified, this will display in place of the page title within tabs/menus:<br />
                  <Input onChange={this.props.onTabTitleChange} value={this.props.tabTitle || ''} />
                </Label>
              </CardBlock>
            </Card>
            <Card className='mb-2'>
              <CardHeader>Hide tab bar for this page</CardHeader>
              <CardBlock>
                <Label check>
                  <Input type='checkbox' checked={this.props.hideTabs === true || this.props.hideTabs === 1} onChange={this.props.onHideTabsChange} />{'  '}
                  The tab bar (of sibling pages) will be hidden on this page. Note that this does not affect whether this page is included in menus or tabs of sibling pages (see 'Show this page in tabs/menus' setting above)
                </Label>
              </CardBlock>
            </Card>
            <Card className='mb-2'>
              <CardHeader>Page accent color</CardHeader>
              <CardBlock>
                <Form inline>
                  <FormGroup check>
                    <Label check>
                      <Input type='radio' name='accentColor'
                        checked={this.props.accentColor === 'green' || !this.props.accentColor || ['green', 'orange', 'pink', 'blue', 'idGray'].indexOf(this.props.accentColor) === -1}
                        value='green'
                        onChange={this.props.onAccentColorChange} />{' '}
                      Green (Default)
                    </Label>
                  </FormGroup>
                  &nbsp;&nbsp;
                  <FormGroup check>
                    <Label check selected>
                      <Input type='radio' name='accentColor'
                        checked={this.props.accentColor === 'orange'}
                        value='orange'
                        onChange={this.props.onAccentColorChange} />{' '}
                      Orange{' '}
                    </Label>
                  </FormGroup>
                  &nbsp;&nbsp;
                  <FormGroup check>
                    <Label check selected>
                      <Input type='radio' name='accentColor'
                        checked={this.props.accentColor === 'pink'}
                        value='pink'
                        onChange={this.props.onAccentColorChange} />{' '}
                      Pink{' '}
                    </Label>
                  </FormGroup>
                  &nbsp;&nbsp;
                  <FormGroup check>
                    <Label check selected>
                      <Input type='radio' name='accentColor'
                        checked={this.props.accentColor === 'blue'}
                        value='blue'
                        onChange={this.props.onAccentColorChange} />{' '}
                      Blue{' '}
                    </Label>
                  </FormGroup>
                  &nbsp;&nbsp;
                  <FormGroup check>
                    <Label check selected>
                      <Input type='radio' name='accentColor'
                        checked={this.props.accentColor === 'idGray'}
                        value='idGray'
                        onChange={this.props.onAccentColorChange} />{' '}
                      Gray{' '}
                    </Label>
                  </FormGroup>
                </Form>
              </CardBlock>
            </Card>
            <Card className='mb-2'>
              <CardHeader>Delete Page</CardHeader>
              <CardBlock>
                <div>
                  {this.props.linkedBy && this.props.linkedBy.length ? <div>Cannot delete page as referenced by:</div> : ''}
                  <ul>
                    {
                      this.props.linkedBy && this.props.linkedBy.map(linker => {
                        return <li key={linker.id}>
                          <Link to={`/pages/edit/${linker.id}`}>{linker.title} <Badge>{linker.count}</Badge> </Link>
                        </li>
                      })
                    }
                  </ul>
                  <ConfirmButton title='Delete Page' disabled={!!(this.props.linkedBy && this.props.linkedBy.length)}
                    message='Are you sure you want to delete this page?' onConfirm={this.props.onDelete}
                    color='danger'><FaTrashO /> Delete</ConfirmButton>
                </div>
              </CardBlock>
            </Card>

          </TabPane>
        </TabContent>
      </div>
    )
  }
}

EditPage.propTypes = {
  pageId: PropTypes.number,
  parentId: PropTypes.number,
  requeueCount: PropTypes.number,
  scheduledFor: PropTypes.string,
  slug: PropTypes.string,
  canonical: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  headTitle: PropTypes.string,
  tabTitle: PropTypes.string,
  showTab: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  hideTabs: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  accentColor: PropTypes.string,
  readOnly: PropTypes.bool,
  sections: PropTypes.array,
  pages: PropTypes.array,
  childPageTotal: PropTypes.number,
  childPageLimit: PropTypes.number,
  parents: PropTypes.array,
  linkedBy: PropTypes.array,
  draftId: PropTypes.number,
  publishedId: PropTypes.number,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  isCopying: PropTypes.bool,
  onAddSection: PropTypes.func.isRequired,
  onRemoveSection: PropTypes.func.isRequired,
  onMoveSection: PropTypes.func.isRequired,
  onCopySection: PropTypes.func.isRequired,
  onSectionChange: PropTypes.func.isRequired,
  onTabTitleChange: PropTypes.func.isRequired,
  onTitleChange: PropTypes.func.isRequired,
  onHeadTitleChange: PropTypes.func,
  onDescriptionChange: PropTypes.func,
  onShowTabChange: PropTypes.func.isRequired,
  onHideTabsChange: PropTypes.func.isRequired,
  onAccentColorChange: PropTypes.func.isRequired,
  onSlugChange: PropTypes.func.isRequired,
  onCanonicalChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPreview: PropTypes.func.isRequired,
  onDirectPreview: PropTypes.func.isRequired,
  isScheduledForPast: PropTypes.func.isRequired,
  onPageSort: PropTypes.func.isRequired,
  onUnpublish: PropTypes.func.isRequired,
  onDeleteDraft: PropTypes.func.isRequired,
  onPublishNow: PropTypes.func.isRequired,
  onCopyPage: PropTypes.func,
  onPublishLater: PropTypes.func.isRequired,
  match: PropTypes.object,
  history: PropTypes.object,
  didModifySections: PropTypes.bool,
  onResetDidModifySections: PropTypes.func,
  isTestEnv: PropTypes.bool,
  onChildPageChange: PropTypes.func.isRequired,
  childPageNumber: PropTypes.number
}

export default EditPage



// WEBPACK FOOTER //
// ./src/pages/EditPage/EditPage.js